import { useQuery } from "@tanstack/react-query";

import { checkFinishedGoodsStock } from "~/services/facturaStockGuard";

// Drives the "Generar factura" button's disabled/tooltip state by checking that
// every finished-goods line on the sales request has stock. The edge function
// is the authoritative gate; this only anticipates the block in the UI.
export function useFacturaStockCheck(salesRequestId: string, enabled: boolean) {
  return useQuery({
    queryKey: ["factura-stock-check", salesRequestId],
    queryFn: () => checkFinishedGoodsStock(salesRequestId),
    enabled: enabled && !!salesRequestId,
    staleTime: 30_000,
  });
}
